module.exports = __webpack_public_path__ + "media/images/icon_other-b9d311c8a3c2ffc9cef4e4ade3366918.png";